var Handlebars = require("/home/jenkins/workspace/朵颐 - 发布POS前台/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"menu\">\n    <div class=\"catView\">\n\n    </div>\n    <div class=\"search-panel\">\n        <img src=\"" + require("../../images/pos/POS-2-03.png") + "\"/>\n    </div>\n    <div class=\"search-box hidden\">\n        <input type=\"text\" placeholder=\""
    + container.escapeExpression(__default(require("/home/jenkins/workspace/朵颐 - 发布POS前台/src/hbHelpers/i18n.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),"pos.quick.order.placeholder",{"name":"i18n","hash":{},"data":data}))
    + "\" class=\"search-input\"/>\n        <img src=\"" + require("../../images/pos/x.png") + "\" class=\"close-search hidden\"/>\n    </div>\n    <div class=\"itemView\">\n\n    </div>\n</div>";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/templates/order/Menu.handlebars
// module id = 534
// module chunks = 0